import * as yup from 'yup';

import { propertyContractBaseSchema } from '@/features/Contract/Property/contractBaseSchema';
import { locales } from '@/features/validation/locales';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';
import { testSpecialChars } from '@/utils/strings/strings';

yup.setLocale(locales);

export const hundContractSchema = yup.object({
  name: yup.string().default('').required().test(testSpecialChars),
  alter: yup.string().default('').required(),
  farbe: yup.string().default('').required().test(testSpecialChars),
  geschlecht: yup.string().default('').required(),
});

const hunContractSchema = yup.object({
  hunde: yup.array().default([]).of(hundContractSchema).required(),
});

export const contractSchema = hunContractSchema.concat(
  propertyContractBaseSchema,
);

export type ContractStore = yup.Asserts<typeof contractSchema>;

export const useHunContractStore = genericStoreFactory(
  () => contractSchema.getDefault() as ContractStore,
  'HunContractStore',
);
